module.exports = new __parcel__URL__("Scrum.5153fd82.svg").toString();